import { AstroX } from '../astrox/dist/connect2ic-core-providers-astrox.esm.js';
export { AstroX } from '../astrox/dist/connect2ic-core-providers-astrox.esm.js';
import { InternetIdentity } from '../internet-identity/dist/connect2ic-core-providers-internet-identity.esm.js';
export { InternetIdentity } from '../internet-identity/dist/connect2ic-core-providers-internet-identity.esm.js';
import { PlugWallet } from '../plug-wallet/dist/connect2ic-core-providers-plug-wallet.esm.js';
export { PlugWallet } from '../plug-wallet/dist/connect2ic-core-providers-plug-wallet.esm.js';
import { StoicWallet } from '../stoic-wallet/dist/connect2ic-core-providers-stoic-wallet.esm.js';
export { StoicWallet } from '../stoic-wallet/dist/connect2ic-core-providers-stoic-wallet.esm.js';
import { InfinityWallet } from '../infinity-wallet/dist/connect2ic-core-providers-infinity-wallet.esm.js';
export { InfinityWallet } from '../infinity-wallet/dist/connect2ic-core-providers-infinity-wallet.esm.js';
import { NFID } from '../nfid/dist/connect2ic-core-providers-nfid.esm.js';
export { NFID } from '../nfid/dist/connect2ic-core-providers-nfid.esm.js';
import { _ as _classPrivateFieldGet, a as _classPrivateFieldInitSpec, b as _classPrivateFieldSet } from '../../dist/classPrivateFieldGet-80e919e0.esm.js';
import { _ as _defineProperty } from '../../dist/defineProperty-6a97efcd.esm.js';
import { AstroXWebViewHandler } from '@astrox/sdk-webview';
import { ok, err } from 'neverthrow';
import { I as InitError, C as CreateActorError, a as ConnectError, D as DisconnectError, T as TransferError, B as BalanceError } from '../../dist/connectors-ec5b9dab.esm.js';
export { B as BalanceError, a as ConnectError, C as CreateActorError, D as DisconnectError, I as InitError, N as NFTsError, S as SignError, b as TokensError, T as TransferError } from '../../dist/connectors-ec5b9dab.esm.js';
import { TransactionMessageKind } from '@astrox/sdk-webview/build/types';
import '@astrox/sdk-web';
import '@astrox/connection/lib/esm/types';
import '@astrox/sdk-web/build/types';
import '@dfinity/auth-client';
import '@dfinity/agent';
import 'ic-stoic-identity';

// @ts-ignore
/* babel-plugin-inline-import '../../assets/astrox_light.svg' */
const astroXLogoLight = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNzZweCIgaGVpZ2h0PSIyOHB4IiB2aWV3Qm94PSIwIDAgNzYgMjgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+57yW57uEIDLlpIfku70gMjwvdGl0bGU+CiAgICA8ZGVmcz4KICAgICAgICA8bGluZWFyR3JhZGllbnQgeDE9IjczLjk2ODg5NDIlIiB5MT0iMTAwJSIgeDI9IjI3LjYwNDkxNTYlIiB5Mj0iMCUiIGlkPSJsaW5lYXJHcmFkaWVudC0xIj4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iIzAyQTRFRiIgb2Zmc2V0PSIwJSI+PC9zdG9wPgogICAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjMkRGRkM0IiBvZmZzZXQ9IjEwMCUiPjwvc3RvcD4KICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgIDxsaW5lYXJHcmFkaWVudCB4MT0iNzAuMjMxOTc4MSUiIHkxPSIxMDAlIiB4Mj0iMzEuMDk2NDYzOSUiIHkyPSIwJSIgaWQ9ImxpbmVhckdyYWRpZW50LTIiPgogICAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjMDJBNEVGIiBvZmZzZXQ9IjAlIj48L3N0b3A+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMyREZGQzQiIG9mZnNldD0iMTAwJSI+PC9zdG9wPgogICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgPHBvbHlnb24gaWQ9InBhdGgtMyIgcG9pbnRzPSIwIDAgNDQuNjg5NzYyMiAwIDQ0LjY4OTc2MjIgMjcuNDkwNzM5NCAwIDI3LjQ5MDczOTQiPjwvcG9seWdvbj4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSIxLjAiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSLnvJbnu4TlpIfku70tNCI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik01Ny4wNzkwMzk2LDEyLjU5MDM3NDggQzU3LjA3OTAzOTYsMTIuNTkwMzc0OCA1Ni43MjUzNzQ0LDEzLjY1MDY3MyA1Ni4zNTkwNzgzLDE1LjE4NzE1MzEgTDU2LjIyNjQ1MzgsMTYuNTc2OTY5MSBDNTUuODQ3NTI2OCwyMC42ODU0NjYgNTcuOTM3OTQwOSwyMS44NjU3NjIxIDYyLjM3MTM4NjksMjEuODc5MDk1MiBMNjEuMzYwOTE0OSwyNy40OTE2OTE4IEw2MS4yODUxMjk1LDI3Ljg5NzM5ODcgQzYwLjUxNDY0NDYsMjcuOTYxNTI0NSA1OS42OTk5NTE1LDI3Ljk5OTYxOTEgNTguODQ3MzY1NywyNy45OTk2MTkxIEM0OS40NDk5NzU3LDI3Ljk5OTYxOTEgNDUuODk0Mzc3MiwyMy4zMDc2NDA3IDQ3Ljc2Mzc1MDUsMTQuNjM0NzgyMSBMNDcuOTA5MDA1OCwxMy45NzQ0NzY3IEM0OS42NTgzODU1LDUuODU5NzAzMjMgNTUuODQxMjExNCwwLjc2MTM4MzAxMyA2My43NDgxNTUxLDAuNzYxMzgzMDEzIEM2NC42MDcwNTYzLDAuNzYxMzgzMDEzIDY1LjQwMjgwMzEsMC44MDU4MjY2NTIgNjYuMTQxNzEwOCwwLjg5NTM0ODgzNyBDNjYuMTQxNzEwOCwwLjg5NTM0ODgzNyA2Mi40MDA0MzgsMy42ODA2OTUxMyA2MS4yNzY5MTk0LDQuNTg5ODg0OTkgQzU5LjAyMzU2NjgsNi40MTQ2MTM3OSA1OC4yNzg5NzUyLDguODEyNjY1NTMgNTcuMDg1MzU1MSwxMi41OTAzNzQ4IEw1Ny4wNzkwMzk2LDEyLjU5MDM3NDggWiIgaWQ9IkZpbGwtMSIgZmlsbD0idXJsKCNsaW5lYXJHcmFkaWVudC0xKSIgb3BhY2l0eT0iMC41MDM2MjcyMzIiPjwvcGF0aD4KICAgICAgICAgICAgPHBhdGggZD0iTTY3LjI4NzMzMzQsMTMuMTMwNDI4NSBMNjIuODIwNDE1NSwxMy4xMzA0Mjg1IEM2MC43MjM2ODYsMTMuMTMwNDI4NSA1OC43MTcyNjc0LDE1LjE4NzUzNCA1OC43MTcyNjc0LDE1LjE4NzUzNCBDNTkuMDgzNTYzNSwxMy42NTEwNTM5IDU5LjQzNzIyODgsMTIuNTkwNzU1NyA1OS40MzcyMjg4LDEyLjU5MDc1NTcgTDU5LjQ0MzU0NDIsMTIuNTkwNzU1NyBDNjAuNjM3MTY0Myw4LjgxMzA0NjQ4IDYxLjk4MjM1NTIsNi40MDAzOTE4MyA2NC44NzQ4MzE0LDYuNDc3MjE1ODMgQzY4Ljg0MDkzNDIsNi41ODQ1MTU0NyA2OC4xMTQ2NTc0LDkuMzAxOTI2NSA2Ny4yODczMzM0LDEzLjEzMDQyODUgTTY2LjEwNjM0NDIsMC43NjMwMzM3NzcgQzU4LjE5OTQwMDUsMC43NjMwMzM3NzcgNTIuMDE2NTc0Nyw1Ljg2MDcxOTA4IDUwLjI2NzE5NDksMTMuOTc0ODU3NiBMNTAuMTIxOTM5NiwxNC42MzUxNjMxIEM0OC4yNTI1NjYzLDIzLjMwODAyMTYgNTEuODA4MTY0OCwyOCA2MS4yMDU1NTQ4LDI4IEM2Ni4wODEwODI0LDI4IDY5LjYxNzczNDYsMjYuODI1NDE4MSA3MS44NzIzNTAzLDI1LjY1NzE4NTQgTDc0LjI5NzQ4MzMsMTkuODYxMSBDNzIuMDY4MTI5MywyMC42NzMxNDg4IDY3LjkxMjU2MywyMS44Nzk0NzYxIDY0Ljc4NjQxNTEsMjEuODc5NDc2MSBDNjAuMzE1MDc2MywyMS44Nzk0NzYxIDU4LjIwNTcxNTksMjAuNzA1NTI5MiA1OC41ODQ2NDMsMTYuNTc4NjE5OSBMNzQuOTEwMDgxOSwxNi41Nzg2MTk5IEw3NS4zOTYzNzE2LDE0LjMzMTA0MTYgQzc3LjI1OTQyOTQsNS43MDg5NzU4IDc0Ljk4NTg2NzMsMC43NjMwMzM3NzcgNjYuMTA2MzQ0MiwwLjc2MzAzMzc3NyIgaWQ9IkZpbGwtMyIgZmlsbD0iIzIzMjMyRiI+PC9wYXRoPgogICAgICAgICAgICA8cGF0aCBkPSJNMTcuNDg3NDgxOCwwLjc0MjkwNzE1OCBMMTIuNjgxNDI0MiwyNy40OTE2MjgzIEw1LjA3MTMwNjU3LDI3LjQ5MTYyODMgTDkuMDg3OTMyOTUsOC44ODE4MDcxMyBDOS4yNzEwODEwMSw3Ljk2MTgyMzgyIDQuMjUwMjk4MDQsOC44NTA2OTY1OSAwLDEyLjI0NzQ2MDQgTDAuNjY5NDM3NzMsOC44MTg5NTExMyBDMi43NDA5MDU0Miw1LjM4OTgwNjk5IDQuNzU1NTM0MDYsMi43MzY1MjE3OSA5LjI5NjM0MjgxLDAuOTQ1NDQzMTY3IEMxMi4xNjM1NTcyLC0wLjE5MTA0NDE1MyAxNS42NTYwMDEyLC0wLjM1NTQ4NTYxNSAxNy40ODc0ODE4LDAuNzQyOTA3MTU4IiBpZD0iRmlsbC01IiBmaWxsPSJ1cmwoI2xpbmVhckdyYWRpZW50LTIpIiBvcGFjaXR5PSIwLjUwMTM0ODU4NiI+PC9wYXRoPgogICAgICAgICAgICA8ZyBpZD0i57yW57uEIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyLjkyODkxNiwgMC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxtYXNrIGlkPSJtYXNrLTQiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNwYXRoLTMiPjwvdXNlPgogICAgICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICAgICAgPGcgaWQ9IkNsaXAtOCI+PC9nPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTQxLjE4NTU3NzQsMjIuNzkxMTQyMSBMNDQuNDA4OTgzMyw3Ljg1MzYzNTMxIEM0NS41MzE4NzAzLDIuNjUwNTU1MDkgNDMuMjE3ODg5MywwLjc2MzYwNTE5NSAzOC43MDA0NDc4LDAuNzYzNjA1MTk1IEMzNS41MTc0NjA4LDAuNzYzNjA1MTk1IDMzLjM4MTU3NTUsMi44NzY1ODI3NCAzMS4xNzExNjc5LDUuMzkyNzI3NTcgTDMxLjEzMzkwNjgsNS4xNzExNDQyOSBDMzAuOTE1MzkyMiwyLjk5Mjc3MTExIDI4LjU5MzIwMTEsMC43NjM2MDUxOTUgMjUuNTY0MzExMiwwLjc2MzYwNTE5NSBDMjIuMTI0Mjg1NCwwLjc2MzYwNTE5NSAyMC4zMzUxMTg0LDIuODMyNzc0MDEgMTguNjA1MzE2NSw0Ljk2NzMzODQ2IEwxOC4yMzM5NjgsNS40OTgxMjI0OCBMMTguMjA5OTY5Myw1LjQ4NDE1NDQ4IEwxOC41OTI2ODU2LDMuODM2NTY1MzIgQzE5Ljc3MDUxNzEsLTAuMjM4MjgxMzkyIDEzLjc3MTQ3MDksLTAuODI3NDc3MDUzIDkuMjkwNjU4OSwwLjk0NDU1NDI5NCBDNC43NTIzNzYzMywyLjczODgwNzQ2IDIuNzM5MDEwNzksNS4zOTMzNjI0OCAwLjY2OTQzNzczLDguODIxODcxNzEgTDAsMTIuMjQ3ODQxMyBDNC4yNDM5ODI1OSw4Ljg0OTgwNzcxIDkuMjY3MjkxNzQsNy45NjQxMDk0OSA5LjA4MzUxMjE0LDguODg1MzYyNjIgTDUuMDY4NzgwMzksMjcuNDkwNzM5NCBMMTMuODQ3MjU2MywyNy40OTA3Mzk0IEwxNy45NzUwMzQ2LDguMzYzNDY3MzMgQzE5LjAyMDg3MzEsNy43MzE3MzI3NiAxOS44MjczNTYxLDcuNDQ3MjkzNDcgMjAuNzc3ODMxNCw3LjQ5NjE4MTQ4IEMyMi40MTg1ODU0LDcuNTgwNjI0MzkgMjIuNDU3MTA5Niw4LjI2MTI0Njk2IDIyLjAxNjkyMjgsMTAuMzAxODQ0OSBMMTguMzA3MjI3MywyNy40OTA3Mzk0IEwyNy4wMzUxNzk2LDI3LjQ5MDczOTQgTDMxLjAzMDk2NDksOC45NzU1MTk3MiBDMzEuMDYzODA1Myw4LjgyMjUwNjYyIDMxLjA5OTgwMzQsOC41MTY0ODA0MyAzMS4xMTExNzEyLDguMzYzNDY3MzMgQzMyLjIxOTUzMjcsNy42NzIwNTEzIDMyLjgwNjg2OTYsNy41MDgyNDQ3NSAzMy4yNjg1MjksNy40OTYxODE0OCBDMzUuMzg0MjA0OCw3LjQ0MzQ4NDAyIDM1LjU5Mzg3NzgsOC4yNjEyNDY5NiAzNS4xNTMwNTkzLDEwLjMwMTg0NDkgTDMxLjQ0Mzk5NTQsMjcuNDkwNzM5NCBMMzYuMTkxOTUwOSwyNy40OTA3Mzk0IEw0MC4xNzEzMTYxLDI3LjQ5MDczOTQgTDQyLjc5MTU5NjUsMjcuNDkwNzM5NCBDNDIuNzkxNTk2NSwyNy40OTA3Mzk0IDQwLjM3OTA5NDQsMjYuNTI4MjE3MiA0MS4xODU1Nzc0LDIyLjc5MTE0MjEiIGlkPSJGaWxsLTciIGZpbGw9IiMyMzIzMkYiIG1hc2s9InVybCgjbWFzay00KSI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="; // @ts-ignore
/* babel-plugin-inline-import '../../assets/astrox.png' */
const astroXLogoDark = "data:image/png;base64,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";
var _config = /*#__PURE__*/new WeakMap();
var _ic = /*#__PURE__*/new WeakMap();
var _principal = /*#__PURE__*/new WeakMap();
var _supportedTokenList = /*#__PURE__*/new WeakMap();
var _wallet = /*#__PURE__*/new WeakMap();
class ICX {
  get principal() {
    return _classPrivateFieldGet(this, _principal);
  }
  get wallets() {
    return _classPrivateFieldGet(this, _wallet) ? [_classPrivateFieldGet(this, _wallet)] : [];
  }
  constructor() {
    let userConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _defineProperty(this, "meta", {
      features: ["wallet"],
      icon: {
        light: astroXLogoLight,
        dark: astroXLogoDark
      },
      id: "icx",
      name: "ICX"
    });
    _classPrivateFieldInitSpec(this, _config, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _ic, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _principal, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _supportedTokenList, {
      writable: true,
      value: []
    });
    _classPrivateFieldInitSpec(this, _wallet, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(this, _config, {
      whitelist: [],
      providerUrl: "https://63k2f-nyaaa-aaaah-aakla-cai.raw.ic0.app",
      ledgerCanisterId: "ryjl3-tyaaa-aaaaa-aaaba-cai",
      ledgerHost: "https://boundary.ic0.app/",
      host: window.location.origin,
      dev: true,
      noUnify: false,
      ...userConfig
    });
    _classPrivateFieldSet(this, _ic, new AstroXWebViewHandler());
    // // @ts-ignore
    // this.#ic = window.icx as AstroXWebViewHandler
  }

  set config(config) {
    _classPrivateFieldSet(this, _config, {
      ..._classPrivateFieldGet(this, _config),
      ...config
    });
  }
  get config() {
    return _classPrivateFieldGet(this, _config);
  }
  async init() {
    try {
      await _classPrivateFieldGet(this, _ic).init();
      // @ts-ignore
      _classPrivateFieldSet(this, _supportedTokenList, await _classPrivateFieldGet(this, _ic).getSupportedTokenList());
      const isConnected = await this.isConnected();
      // TODO: never connected
      if (isConnected) {
        _classPrivateFieldSet(this, _principal, _classPrivateFieldGet(this, _ic).getPrincipal().toText());
        _classPrivateFieldSet(this, _wallet, _classPrivateFieldGet(this, _ic).wallet);
        if (_classPrivateFieldGet(this, _config).dev) {
          await _classPrivateFieldGet(this, _ic).agent.fetchRootKey();
        }
      }
      return ok({
        isConnected
      });
    } catch (e) {
      console.error(e);
      return err({
        kind: InitError.InitFailed
      });
    }
  }
  async isConnected() {
    try {
      if (!_classPrivateFieldGet(this, _ic)) {
        return false;
      }
      const isConnected = await _classPrivateFieldGet(this, _ic).isConnected();
      // TODO: fix at astrox-js-sdk
      return !!isConnected;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  // TODO: export & use types from astrox/connection instead of dfinity/agent
  async createActor(canisterId, idlFactory) {
    try {
      if (!_classPrivateFieldGet(this, _ic)) {
        return err({
          kind: CreateActorError.NotInitialized
        });
      }
      // @ts-ignore
      const actor = await _classPrivateFieldGet(this, _ic).createActor(canisterId, idlFactory);
      if (!actor) {
        return err({
          kind: CreateActorError.CreateActorFailed
        });
      }
      // @ts-ignore
      return ok(actor);
    } catch (e) {
      console.error(e);
      return err({
        kind: CreateActorError.CreateActorFailed
      });
    }
  }
  async connect() {
    try {
      if (!_classPrivateFieldGet(this, _ic)) {
        return err({
          kind: ConnectError.NotInitialized
        });
      }
      await _classPrivateFieldGet(this, _ic).connect({
        delegationModes: _classPrivateFieldGet(this, _config).delegationModes,
        delegationTargets: _classPrivateFieldGet(this, _config).whitelist,
        host: _classPrivateFieldGet(this, _config).host,
        noUnify: _classPrivateFieldGet(this, _config).noUnify,
        customDomain: _classPrivateFieldGet(this, _config).customDomain
      });
      _classPrivateFieldSet(this, _principal, _classPrivateFieldGet(this, _ic).getPrincipal().toText());
      _classPrivateFieldSet(this, _wallet, _classPrivateFieldGet(this, _ic).wallet);
      if (_classPrivateFieldGet(this, _config).dev) {
        await _classPrivateFieldGet(this, _ic).agent.fetchRootKey();
      }
      return ok(true);
    } catch (e) {
      console.error(e);
      return err({
        kind: ConnectError.ConnectFailed
      });
    }
  }
  async disconnect() {
    try {
      await _classPrivateFieldGet(this, _ic)?.disconnect();
      return ok(true);
    } catch (e) {
      console.error(e);
      return err({
        kind: DisconnectError.DisconnectFailed
      });
    }
  }
  async requestTransferNFT(args) {
    try {
      const {
        tokenIdentifier,
        tokenIndex,
        canisterId,
        standard,
        to,
        fee = 0,
        memo = BigInt(0),
        createdAtTime = new Date(),
        fromSubAccount = 0
      } = args;
      if (!_classPrivateFieldGet(this, _ic)) {
        return err({
          kind: TransferError.NotInitialized
        });
      }
      const response = await _classPrivateFieldGet(this, _ic).requestTransfer({
        tokenIdentifier,
        tokenIndex,
        canisterId,
        standard,
        to,
        sendOpts: {
          fee: BigInt(fee),
          memo,
          from_subaccount: fromSubAccount,
          created_at_time: createdAtTime
        }
      });
      if (response.kind === TransactionMessageKind.fail) {
        return err({
          kind: TransferError.TransferFailed
        });
      }
      if (response.kind === TransactionMessageKind.success) {
        return ok({
          ...response.payload
        });
      }
      return err({
        kind: TransferError.TransferFailed
      });
    } catch (e) {
      console.error(e);
      return err({
        kind: TransferError.TransferFailed
      });
    }
  }
  async requestTransfer(opts) {
    const {
      to,
      amount,
      standard = "ICP",
      symbol = "ICP",
      decimals = 8,
      fee = 0,
      memo = BigInt(0),
      createdAtTime = new Date(),
      fromSubAccount = 0
    } = opts;
    try {
      const tokenInfo = _classPrivateFieldGet(this, _supportedTokenList).find(_ref => {
        let {
          symbol: tokenSymbol
        } = _ref;
        return symbol === tokenSymbol;
      });
      if (!tokenInfo) {
        return err({
          kind: TransferError.TokenNotSupported
        });
      }
      // @ts-ignore
      const response = await _classPrivateFieldGet(this, _ic)?.requestTransfer({
        //@ts-ignore
        amount: BigInt(amount * 10 ** tokenInfo.decimals),
        to,
        symbol,
        standard,
        sendOpts: {
          fee: BigInt(fee),
          memo,
          from_subaccount: fromSubAccount,
          created_at_time: createdAtTime
        }
      });
      if (!response || response.kind === TransactionMessageKind.fail) {
        // message?
        return err({
          kind: TransferError.TransferFailed
        });
      }
      if (response.kind === TransactionMessageKind.success) {
        return ok({
          ...response.payload,
          height: response.payload.blockHeight ?? Number(response.payload.blockHeight)
        });
      }
      return err({
        kind: TransferError.TransferFailed
      });
    } catch (e) {
      console.error(e);
      return err({
        kind: TransferError.TransferFailed
      });
    }
  }
  async queryBalance() {
    try {
      if (!_classPrivateFieldGet(this, _ic)) {
        return err({
          kind: BalanceError.NotInitialized
        });
      }
      const response = await _classPrivateFieldGet(this, _ic).queryBalance();
      response.forEach(token => token.amount = token.amount / 10 ** token.decimals);
      return ok(response);
    } catch (e) {
      console.error(e);
      return err({
        kind: BalanceError.QueryBalanceFailed
      });
    }
  }

  // async queryTokens() {
  //   try {
  //     if (!this.#ic) {
  //       return err({ kind: TokensError.NotInitialized })
  //     }
  //     const response = await this.#ic.queryBalance()
  //     return ok(response)
  //   } catch (e) {
  //     console.error(e)
  //     return err({ kind: TokensError.QueryBalanceFailed })
  //   }
  // }

  // async queryNFTs() {
  //   try {
  //     if (!this.#ic) {
  //       return err({ kind: NFTsError.NotInitialized })
  //     }
  //     // const response = await this.#ic.queryBalance()
  //     return ok(response)
  //   } catch (e) {
  //     console.error(e)
  //     return err({ kind: NFTsError.QueryBalanceFailed })
  //   }
  // }

  // TODO:
  // public async signMessage(message: string): Promise<any> => this.#ic.signMessage(message)
  // getManagementCanister: (...args) => this.#ic.getManagementCanister(...args),
  // batchTransactions: (...args) => this.#ic.batchTransactions(...args),
}

let isICX = !!window.icx;
const defaultProviders = config => {
  return isICX ? [new ICX(config)] : [new AstroX(config),
  // EarthWallet,
  new InfinityWallet(config), new InternetIdentity(config), new NFID(config), new PlugWallet(config), new StoicWallet(config)];
};
const walletProviders = config => {
  return isICX ? [new ICX(config)] : [new AstroX(config), new PlugWallet(config)];
};

export { ICX, defaultProviders, walletProviders };
